export default "__VITE_ASSET__$Ct228rG__"